import { useState, useCallback, useEffect } from "react";

import { message } from 'antd';

let logoutTimer;

const useAuth = () => {
    const [token, setToken] = useState(null);
    const [role, setRole] = useState('viewer');
    const [name, setName] = useState(null);
    const [image, setImage] = useState(null);
    const [username, setUsername] = useState(null);
    const [email, setEmail] = useState(null);
    const [phone, setPhone] = useState(null);
    const [tokenExpirationDate, setTokenExpirationDate] = useState();
    const [userId, setUserId] = useState(false);
    const [isPaymentDue, setIsPaymentDue] = useState(false);

    const checkPaymentDue = (paymentDate) => {
        if (!paymentDate) {
            return { isDue: true, message: "UnSubscribed" };
        }
    
        const paymentDateObject = new Date(paymentDate);
    
        const currentDate = new Date();
    
        const differenceInMilliseconds = currentDate - paymentDateObject;
    
        const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    
        if (differenceInDays >= 365) {
            return { isDue: true, message: "Due Payment" };
        }
    
        return { isDue: false, message: "Active" };
    }

    const login = useCallback((uid, token, role, username, name, image, email, lastPaymentDate="", phone="", expirationDate) => {
        setToken(token);
        setUserId(uid);
        setRole(role);
        setUsername(username);
        setName(name);
        setImage(image);
        setEmail(email);
        setPhone(phone);
        const tokenExpirationDate = expirationDate || new Date(new Date().getTime() + 1 * 60 * 60 * 1000);
        setTokenExpirationDate(tokenExpirationDate);
        localStorage.setItem('storec-userData',
            JSON.stringify({
                userId: uid,
                token: token,
                expiration: tokenExpirationDate.toISOString(),
                role: role,
                username: username,
                name: name,
                image: image,
                email: email,
                lastPaymentDate: lastPaymentDate,
                phone: phone
            }));
        setIsPaymentDue(role === 'store' && checkPaymentDue(lastPaymentDate).isDue);
    }, []);

    const logout = useCallback(() => {
        setToken(null);
        setTokenExpirationDate(null);
        setUserId(null);
        setRole('viewer');
        setUsername(null);
        setName(null);
        setImage(null);
        setEmail(null);
        setPhone(null);
        setIsPaymentDue(false);
        localStorage.removeItem('storec-userData');
        message.destroy("payment");
    }, []);

    const updateAuth = useCallback((updatedData) => {

        const storedData = JSON.parse(localStorage.getItem('storec-userData'));

        if (storedData) {
            const updatedUserData = {
                ...storedData,
                email: updatedData.email,
                name: updatedData.name,
                image: updatedData.image,
                phone: updatedData.phone,
            };

            setEmail(updatedData.email);
            setName(updatedData.name);
            setImage(updatedData.image);
            setPhone(updatedData.phone);

            localStorage.setItem('storec-userData', JSON.stringify(updatedUserData));
        }
    }, [setEmail, setName, setImage, setPhone]);
    

    useEffect(() => {
        if (token && tokenExpirationDate) {
            const remainingTime = tokenExpirationDate.getTime() - new Date().getTime();
            logoutTimer = setTimeout(logout, remainingTime);
        } else {
            clearTimeout(logoutTimer);
        }
    }, [token, logout, tokenExpirationDate, role]);

    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem('storec-userData'));
        if (storedData && storedData.token && (new Date(storedData.expiration) > new Date())) {
            login(storedData.userId, storedData.token, storedData.role, storedData.username, storedData.name, storedData.image, storedData.email, storedData?.lastPaymentDate, storedData?.phone, new Date(storedData.expiration));
        } else {
            logout();
        }
    }, [login, logout]);

    return {
        userId,
        login,
        logout,
        updateAuth,
        token,
        role,
        username,
        name,
        image,
        email,
        phone,
        isPaymentDue,
    };
}

export default useAuth;